import { RootState } from "store";

export const getAddressStore = (state: RootState) => state.addresses;
export const getAddressesList = (state: RootState) => state.addresses.list;
